import SovietSubscriptionSpacer from './sovietSubscriptionSpacer'

{
  $('.js__sovietSubscriptionSpacer').each(function() {
    $(this).reactify(SovietSubscriptionSpacer, $(this).data())
  })
}
